import { render, staticRenderFns } from "./GetReceiveInfo.vue?vue&type=template&id=59c881bd&scoped=true&"
import script from "./GetReceiveInfo.vue?vue&type=script&lang=js&"
export * from "./GetReceiveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c881bd",
  null
  
)

export default component.exports